/// <amd-module name="Reporting/BurndownReport/NotConfiguredMessages" />
import * as React from "react";
import * as CommonResources from "Reporting/BoardsCommon/Resources";
import * as Resources from "Reporting/BurndownReport/Resources";
import { VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { ZeroData } from "VSSUI/ZeroData";

/** For iterations which are not configured on WIT side */
export class IterationNotConfiguredMessage extends VssComponent {
    public render(): JSX.Element {
        const imagePath = getAssetLocation(
            this.context.pageContext,
            "ms.vss-reporting-web/boards-reporting-common-content/images/data-not-ready.svg"
        );
        return (
            <ZeroData
                primaryText={Resources.WITIterationNotConfiguredWarningHeader}
                secondaryText={<span>{Resources.WITIterationNotConfiguredWarningDetail}</span>}
                imageAltText={CommonResources.DataNotReadyImageDescription}
                imagePath={imagePath}
            />
        );
    }
}

/** For iterations which are unrecognized by AX service. */
export class IterationNotFoundInAxMessage extends VssComponent {
    public render(): JSX.Element {
        const imagePath = getAssetLocation(
            this.context.pageContext,
            "ms.vss-reporting-web/boards-reporting-common-content/images/data-not-found.svg"
        );
        return (
            <ZeroData
                primaryText={Resources.AxIterationNotFoundWarningHeader}
                secondaryText={<span>{Resources.AxIterationNotFoundWarningDetail}</span>}
                imageAltText={CommonResources.DataNotFoundImageDescription}
                imagePath={imagePath}
            />
        );
    }
}

/** For iterations which are unrecognized by AX service. */
export class IterationDatesNotFoundInAxMessage extends VssComponent {
    public render(): JSX.Element {
        const imagePath = getAssetLocation(
            this.context.pageContext,
            "ms.vss-reporting-web/boards-reporting-common-content/images/data-not-found.svg"
        );
        return (
            <ZeroData
                primaryText={Resources.AxIterationDatesNotFoundWarningHeader}
                secondaryText={<span>{Resources.AxIterationDatesNotFoundWarningDetail}</span>}
                imageAltText={CommonResources.DataNotFoundImageDescription}
                imagePath={imagePath}
            />
        );
    }
}

export function getKnownWarningComponent(warningMessage: string): JSX.Element | null {
    if (warningMessage === Resources.WITIterationNotConfiguredWarningDetail) {
        return <IterationNotConfiguredMessage />;
    } else if (warningMessage === Resources.AxIterationNotFoundWarningDetail) {
        return <IterationNotFoundInAxMessage />;
    } else if (warningMessage === Resources.AxIterationDatesNotFoundWarningDetail) {
        return <IterationDatesNotFoundInAxMessage />;
    }
    return null;
}
